/// <reference path="../../../teva/storage/storage.ts" />
/// <reference path="../../../teva/datepicker/datepicker.ts" />
/// <reference path="../common/common.ts" />

namespace OfficeGuy {
    declare var dataLayer;

    export class ExternalProvider {
        static PageURL;

        static PageLoadCustomerTracking(GoogleAnalyticsTrackingID, FacebookPixelTrackingID) {
            dataLayer.push({
                'event': 'og-customer-pageload',
                'og-customer-google-analytics': GoogleAnalyticsTrackingID,
                'og-customer-facebook-pixel': FacebookPixelTrackingID
            });
        }

        static AdditionalFacebookEvent(Pixel, Event, Data) {
            dataLayer.push({
                'event': 'og-customer-event',
                'og-customer-facebook-pixel': Pixel,
                'og-customer-facebook-pixel-event': Event,
                'og-customer-facebook-pixel-data': Data
            });
        }

        static PageLoadClearReferrer() {
            /*gtag('set', {
                'referrer': Common.FullRootURL
            });*/
        }

        static PageLoad(URL) {
            ExternalProvider.PageURL = URL;
            dataLayer.push({ 'event': 'og-pageload' });

            if (Common.LoggedUserID != null && Common.LoggedUserID != 0 && Teva.Storage.LocalStorage_Supported()) {
                var LastLoginDate = Teva.Storage.LocalStorage_Get("LastLoginDate");
                var DateString = Teva.DatePicker.GetDateAsString(new Date());
                if (LastLoginDate == null || LastLoginDate != DateString) {
                    ExternalProvider.PushEvent("Users", "Login", "", "");
                    Teva.Storage.LocalStorage_Set("LastLoginDate", DateString);
                }
            }
        }

        static PushEvent(Category, Action, Label, Value) {
            if (Value == '')
                Value = null;

            dataLayer.push({
                'event': 'og-event',
                'og-event-category': Category,
                'og-event-action': Action,
                'og-event-label': Label,
                'og-event-value': Value
            });
        }
    }
}

$(document).on("Teva.PageLoad", function () {
    OfficeGuy.ExternalProvider.PageLoad(window.location.pathname);
});
